export const META_TITLE = 'ALL – Accor Live Limitless'

export const PAGE_NAME_NAVIGATION: Record<string, string> = {
  preview: 'account::homepage',
  'your reservation': 'account::bookings',
  'your loyalty account': 'account::loyalty',
  'your account activity': 'account::activity',
  'your partners': 'account::your partner benefits',
  'your subscriptions': 'account::hub subscriptions',
  'unlock more advantages': 'account::unlock more advantages',
  'your information': 'account::my information',
  'stay preferences': 'account::stay preferences',
  'your preferences': 'account::profile::newsletters',
  'security settings': 'account::security settings'
}

export const SECURITY_SETTINGS = 'security-settings'
